module.exports = __webpack_public_path__ + "static/media/transgrid.5729591d.png";